// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"OQIiT","loader":"ftQDN","testHeader":"ZfleH","container":"XhKOz","statsTop":"PNzwk","grid":"bAZPd","statsBottom":"MKk5b","projectTop":"TSiCA","scrollButton":"D2fHk"};